import axios from 'axios';
import { getEnvironment } from '@global/helpers';
const Config = getEnvironment();

const baseUrl = Config.MS_B2B_ACCOUNTS_API_URL;

const getRoles = (params = {}) => {
  return axios.get(`${baseUrl}/roles`, params);
};

const getUsers = (params = {}) => {
  return axios.get(`${baseUrl}/users`, params);
};

const getUsersCount = (params = {}) => {
  return axios.get(`${baseUrl}/users/count`, params);
};

const getUserDetail = (id) => {
  return axios.get(`${baseUrl}/users/${id}`);
};

const inviteUser = (id) => {
  return axios.post(`${baseUrl}/users/${id}/invitation`);
};

const createBulkUser = (payload = {}) => {
  return axios.post(`${baseUrl}/users/bulk`, payload);
};

const createBulkCustomer = (payload = {}) => {
  return axios.post(`${baseUrl}/customers/bulk`, payload);
};

const createUser = (payload = {}) => {
  return axios.post(`${baseUrl}/users`, payload);
};

const updateUser = (id, payload = {}) => {
  return axios.put(`${baseUrl}/users/${id}`, payload);
};

const updateVersion = (payload = {}) => {
  return axios.post(`${baseUrl}/users/update-version`, payload);
};

const deleteUser = (id) => {
  return axios.delete(`${baseUrl}/users/${id}`);
};

const changeUserState = (id, payload = {}) => {
  return axios.put(`${baseUrl}/users/${id}/state`, payload);
};

const getBranches = (params = {}) => {
  return axios.get(`${baseUrl}/branches`, params);
};

const getAllBranches = (params = {}) => {
  return axios.get(`${baseUrl}/branches/all`, params);
};

const getBranchesCount = (params = {}) => {
  return axios.get(`${baseUrl}/branches/count`, params);
};

const getBranchDetail = (id) => {
  return axios.get(`${baseUrl}/branches/${id}`);
};

const createBranch = (payload = {}) => {
  return axios.post(`${baseUrl}/branches`, payload);
};

const updateBranch = (id, payload = {}) => {
  return axios.put(`${baseUrl}/branches/${id}`, payload);
};

export const getCustomersAssigned = (params = {}) => {
  return axios.get(`${baseUrl}/customers/assigned`, params);
};

export const createCustomersQuick = (payload = {}) => {
  return axios.post(`${baseUrl}/customers/quick-register`, payload);
};

export const createCustomers = (payload = {}) => {
  return axios.post(`${baseUrl}/customers`, payload);
};

export const updateCustomers = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}`, payload);
};

export const patchCustomerSalesTeamPersons = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}/sales-team-persons`, payload);
};

export const updateCustomerAddressPremium = (id, addressId, payload = {}) => {
  return axios.put(
    `${baseUrl}/customers/${id}/address/${addressId}/premium`,
    payload,
  );
};

const exportPdfCustomer = (id) => {
  return axios.post(`${baseUrl}/customers/${id}/pdf`);
};

export const getCustomers = (params = {}) => {
  return axios.get(`${baseUrl}/customers`, params);
};

export const getCustomersSearch = (params = {}) => {
  return axios.get(`${baseUrl}/customers/search`, params);
};

export const getCustomersCount = (params = {}) => {
  return axios.get(`${baseUrl}/customers/count`, params);
};

export const getCustomerId = (id) => {
  return axios.get(`${baseUrl}/customers/${id}`);
};

export const getCustomerInvoice = (id, payload = {}) => {
  return axios.get(`${baseUrl}/customers/${id}/invoice`, payload);
};

export const updateCustomerById = (id, payload) => {
  return axios.put(`${baseUrl}/customers/${id}`, payload);
};

export const importCustomer = (action, payload) => {
  return axios.post(`${baseUrl}/customers/import/${action}`, payload);
};

export const getCountries = (params = {}) => {
  return axios.get(`${baseUrl}/countries`, params);
};

export const getStates = (params = {}) => {
  return axios.get(`${baseUrl}/states`, params);
};

export const getAllStates = (params = {}) => {
  return axios.get(`${baseUrl}/states/all`, params);
};

export const getCities = (params = {}) => {
  return axios.get(`${baseUrl}/cities`, params);
};

export const getAllCities = (params = {}) => {
  return axios.get(`${baseUrl}/cities/all`, params);
};

export const getAllDistricts = (params = {}) => {
  return axios.get(`${baseUrl}/districts/all`, params);
};

export const updateCustomerStateById = (id, state, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}/state/${state}`, payload);
};

export const toggleCustomerSubdis = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}/subdistributor`, payload);
};

export const updateCustomerStatusById = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}/status`, payload);
};

export const updateCustomerDocumentsById = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}/documents`, payload);
};

export const deleteCustomerDocumentsById = (id, documentId) => {
  return axios.delete(`${baseUrl}/customers/${id}/documents/${documentId}`);
};

// .........customers clusters rule
const getCustomerClusterRule = (params = {}) => {
  return axios.get(`${baseUrl}/customers-clusters-rules`, params);
};

const getCustomerClusterRuleDetail = (id) => {
  return axios.get(`${baseUrl}/customers-clusters-rules/${id}`);
};

const getCustomerClusterRuleCount = (params = {}) => {
  return axios.get(`${baseUrl}/customers-clusters-rules/count`, params);
};

const createCustomerClusterRule = (payload = {}) => {
  return axios.post(`${baseUrl}/customers-clusters-rules`, payload);
};

const updateCustomerClusterRule = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers-clusters-rules/${id}`, payload);
};

// .........customers clusters
const getCustomerCluster = (params = {}) => {
  return axios.get(`${baseUrl}/customers-clusters`, params);
};

const getCustomerClusterDetail = (id) => {
  return axios.get(`${baseUrl}/customers-clusters/${id}`);
};

const getCustomerClusterCount = (params = {}) => {
  return axios.get(`${baseUrl}/customers-clusters/count`, params);
};

const createCustomerCluster = (payload = {}) => {
  return axios.post(`${baseUrl}/customers-clusters`, payload);
};

const updateCustomerCluster = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers-clusters/${id}`, payload);
};

const updateCustomerClusterStatus = (
  id,
  clusterId,
  status,
  payload = { reason: 'Customer cluster rejected' },
) => {
  return axios.put(
    `${baseUrl}/customers/${id}/customers-clusters/${clusterId}/${status}`,
    payload,
  );
};

export const getClusterByCustomerId = (id, payload = {}) => {
  return axios.get(`${baseUrl}/customers/${id}/customers-clusters`, payload);
};

export const getCustomerAveragePurchase = (id) => {
  return axios.get(`${baseUrl}/customers/${id}/average-total-purchases`);
};

export const getCustomerTotalInvoice = (id) => {
  return axios.get(`${baseUrl}/customers/${id}/total-invoice-amount`);
};

const getPaymentTerms = (params = {}) => {
  return axios.get(`${baseUrl}/payment_terms`, params);
};

export const getCustomerPoNumber = (id) => {
  return axios.get(`${baseUrl}/customers/${id}/po-number`);
};

export const googleMapsAutocomplete = (params = {}) => {
  return axios.get(`${baseUrl}/gmaps/place-api`, params);
};

export const googleMapsPlaceDetail = (id) => {
  return axios.get(`${baseUrl}/gmaps/place-api/${id}`);
};

export const googleMapsGeocode = (params = {}) => {
  return axios.get(`${baseUrl}/gmaps/geocode-api`, params);
};

const getCreditLimit = (params = {}) => {
  return axios.get(`${baseUrl}/credit-limits`, params);
};

const getCreditLimitCount = (params = {}) => {
  return axios.get(`${baseUrl}/credit-limits/count`, params);
};

const getCreditLimitDetail = (id) => {
  return axios.get(`${baseUrl}/credit-limits/${id}`);
};

const createCreditLimit = (payload = {}) => {
  return axios.post(`${baseUrl}/credit-limits`, payload);
};

const updateCreditLimit = (id, payload = {}) => {
  return axios.put(`${baseUrl}/credit-limits/${id}`, payload);
};

const deleteCreditLimit = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/credit-limits/${id}`, payload);
};

const getCustomerSalesTeam = (id, payload = {}) => {
  return axios.get(`${baseUrl}/customers/${id}`, payload);
};

export const getOutlets = (params = {}) => {
  return axios.get(`${baseUrl}/outlets`, params);
};

export const getOutletsByCustomerId = (id) => {
  return axios.get(`${baseUrl}/outlets/customer/${id}`);
};

export const getOutletsCount = (params = {}) => {
  return axios.get(`${baseUrl}/outlets/count`, params);
};

export const getOutletDetail = (id, params = {}) => {
  return axios.get(`${baseUrl}/outlets/${id}`, params);
};

export const createOutlet = (payload = {}) => {
  return axios.post(`${baseUrl}/outlets`, payload);
};

export const updateOutlet = (id, payload = {}) => {
  return axios.put(`${baseUrl}/outlets/${id}`, payload);
};

export const exportOutlet = () => {
  return axios.get(`${baseUrl}/outlets/export`);
};

export const updateCustomerSignaturesById = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers/${id}/signatures`, payload);
};

const getCustomerLogs = (id, params) => {
  return axios.get(`${baseUrl}/customers/${id}/logs`, { params });
};

const getUserLogs = (id, params) => {
  return axios.get(`${baseUrl}/users/${id}/logs`, { params });
};

const createCustomerType = (payload = {}) => {
  return axios.post(`${baseUrl}/customers-types`, payload);
};

const getCustomerTypes = (params = {}) => {
  return axios.get(`${baseUrl}/customers-types`, params);
};

const updateCustomerType = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customers-types/${id}`, payload);
};

const getCustomerTypeDetail = (id) => {
  return axios.get(`${baseUrl}/customers-types/${id}`);
};

const getCustomerTypeCount = (params = {}) => {
  return axios.get(`${baseUrl}/customers-types/count`, params);
};

export const MsAccount = {
  getRoles,
  getUsers,
  getUsersCount,
  getUserDetail,
  inviteUser,
  createBulkUser,
  createUser,
  updateUser,
  updateVersion,
  deleteUser,
  getBranches,
  getAllBranches,
  getBranchesCount,
  getBranchDetail,
  createBranch,
  updateBranch,
  getCustomersAssigned,
  getCustomers,
  getCustomersSearch,
  getCustomersCount,
  getCustomerId,
  getCustomerInvoice,
  updateCustomerById,
  updateCustomerStateById,
  toggleCustomerSubdis,
  getCountries,
  getStates,
  getCities,
  getCustomerClusterRule,
  getCustomerClusterRuleDetail,
  getCustomerClusterRuleCount,
  updateCustomerClusterRule,
  createCustomerClusterRule,
  getCustomerCluster,
  getCustomerClusterDetail,
  getCustomerClusterCount,
  updateCustomerCluster,
  createCustomerCluster,
  updateCustomerClusterStatus,
  getCustomerAveragePurchase,
  getClusterByCustomerId,
  getPaymentTerms,
  updateCustomerDocumentsById,
  getCustomerTotalInvoice,
  getCustomerPoNumber,
  googleMapsAutocomplete,
  googleMapsPlaceDetail,
  googleMapsGeocode,
  getCreditLimit,
  getCreditLimitCount,
  getCreditLimitDetail,
  createCreditLimit,
  updateCreditLimit,
  deleteCreditLimit,
  changeUserState,
  getCustomerSalesTeam,
  getOutlets,
  getOutletsByCustomerId,
  getOutletsCount,
  getOutletDetail,
  createOutlet,
  updateOutlet,
  exportOutlet,
  exportPdfCustomer,
  updateCustomerSignaturesById,
  getCustomerLogs,
  getUserLogs,
  createCustomerType,
  getCustomerTypes,
  updateCustomerType,
  getCustomerTypeDetail,
  getCustomerTypeCount,
  createBulkCustomer,
  importCustomer,
};
